export interface IState {
    props: IProps
}


export interface IProps{
	links: ILink[],
    isListView: boolean,
    listType: string,
    showTags: boolean,
    showImage: boolean,
    boxFullHeight: boolean,
    sort: string,
    showIngress: boolean
}

interface ILink {
    id: string,
    url: string,
    title: string,
    type: string,
    text: string,
    tags: string[],
    image_url: string
}

const deafultState: IState = {
	props: {
        links: [],
        isListView: true,
        listType: 'block',
        showTags: false,
        showImage: false,
        boxFullHeight: false,
        sort: '',
        showIngress: false
    }
}


export default deafultState;
